export type CatalogueFolder = {
  id: string;
  contextId: string;
};
